import { Component, ComponentFactoryResolver, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { ApiService } from 'app/shared/services/api.service';
import moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { DynamicDetailComponent } from '../../dynamic-detail/dynamic-detail.component';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ListComponent implements OnInit {
  leaveForm:FormGroup
  page = {
    pageNumber: 0,
    offset: 0,
    pageSize: 100,
    totalPages: 0
  };
  public rows = [];
  public filterRows = [];
  public ColumnMode = ColumnMode;
  public limitRef = 100;
  public columns = [
    { name: " Name", prop: "name" },
    { name: "Email", prop: "email" },
    { name: "Actions", prop: "actions" },
  ];
  user_role:any

  task_leave_model={
    title:'',
    body:'',
    label:'643e81d959b78b65557d749e',
    to :'',
    from_date:'',
    to_date:'',
    knowledge_transafer:'',
    status:'643e869259b78b65557d755a'
  }
  task_label_catId = '643e7f6f59b78b65557d744a'

  taskLabelList=[]
  selectedTaskLabel=null
  min_date :any
  max_date :any
  from_date = new FormControl()
  to_date = new FormControl()
  title = new FormControl()
  knowledge_transafer = new FormControl()
  fromDate:any
  toDate:any  
  request_info:any
  reply_info:any
  row_id:any
  row_body:any
  emp_list =[]
  selected_emp = null
  guideline_data:any
  
  constructor( private apiService: ApiService,
                public toastr: ToastrService,
                private modalService: NgbModal, private formBuilder : FormBuilder,
                private spinner: NgxSpinnerService) {
                this.user_role = JSON.parse(localStorage.getItem('user'))
                let setting_data = JSON.parse(localStorage.getItem('setting-record'))
                let key_data = setting_data.filter((item) => item.key == 'Leave Request')
                this.guideline_data = key_data[0]?._id             
   }

  ngOnInit(): void {
   

    let today_date = new Date()
    today_date.setDate(today_date.getDate());
    this.min_date = today_date.toISOString().split('T')[0];

    const maxDate = new Date();
    maxDate.setMonth(maxDate.getMonth() +3);
    this.max_date = maxDate.toISOString().split('T')[0];

    this.task_leave_model.from_date = this.min_date
    this.task_leave_model.to_date = this.min_date

    this.from_date.valueChanges.subscribe((value) => {
      this.task_leave_model.from_date = moment(value).format('L')
    })
    this.to_date.valueChanges.subscribe((value) => {
      this.task_leave_model.to_date =  moment(value).format('L')

    })
    this.title.valueChanges.subscribe((value) => {
      this.task_leave_model.title = value
    })
    this.knowledge_transafer.valueChanges.subscribe((value) => {
      this.task_leave_model.knowledge_transafer = value
    })

    let fromDate = new Date()
    fromDate.setDate(fromDate.getDate() - 1);
    this.fromDate = fromDate.toISOString().split('T')[0];
    this.fromDate = moment(this.fromDate).format('YYYY-MM-DD')
    this.toDate = new Date()
    this.toDate = moment(this.toDate).format('YYYY-MM-DD')

    this.getLeaveList(this.fromDate,this.toDate)
    this.getTaskLabelList()


  }
 
  getStartDate(event){
    this.fromDate = event.target.value
    if(this.fromDate > this.toDate){
      this.toastr.error('invalid date!')
    }
    else{
      if(this.fromDate && this.toDate){
        this.getLeaveList(this.fromDate,this.toDate)
      }
    }
  }
  getEndDate(event){
    this.toDate = event.target.value
    if(this.fromDate > this.toDate){
      this.toastr.error('invalid date!')
    }
    else{
      if(this.fromDate && this.toDate){
        this.getLeaveList(this.fromDate,this.toDate)
      }
    }
  }


  getLeaveList(from_date: string, to_date: string): void {
    this.spinner.show(undefined, {
      type: 'ball-triangle-path',
      size: 'medium',
      bdColor: 'rgba(0, 0, 0, 0.8)',
      color: '#fff',
      fullScreen: true,
    });
  
    this.apiService.getTaskByUserIdWithDate(this.user_role.id, from_date, to_date).subscribe(
      (res: any) => {
        this.spinner.hide();
  
        // Initialize rows and pagination
        const items = res?.data?.items || [];
        this.rows = items.map((item: any) => {
          const body = item.body || '';
          const fromToMatch = body.match(/From :- (\d{2}\/\d{2}\/\d{4})\s+To :- (\d{2}\/\d{2}\/\d{4})/);
          const transferredToMatch = body.match(/Project Transferred To :- (.+?)\n/);
  
          return {
            ...item,
            from: fromToMatch?.[1] || null,
            to: fromToMatch?.[2] || null,
            transferred_to: transferredToMatch?.[1] || null,
          };
        });
  
        this.page.totalPages = res?.data?.totalCount || 0;
      },
      (error: any) => {
        this.spinner.hide();
        console.error('Error fetching leave list:', error);
        // Handle error (e.g., show a notification to the user)
      }
    );
  }
  
  getTaskLabelList() {
    this.apiService.getTagByTagCatgoryId(this.task_label_catId).subscribe((res: any) => {
      this.taskLabelList = res.data
    })
  }
  getChangeTaskLabelId(event) {
    this.selectedTaskLabel
  }
  openModalLeave(content,id,data){
    this.checkEmpAttendence('all')
    
    if(id && data){
      this.row_id = id
      this.task_leave_model.body = data.body
      this.task_leave_model.title = data.title
      this.task_leave_model.from_date = data.from
      this.task_leave_model.to_date = data.to
      this.task_leave_model.knowledge_transafer = data.transferred_to
    }
    const modalOptions: NgbModalOptions = {
      size: 'lg' 
    };
    const modalRef = this.modalService.open(content,modalOptions);
    modalRef.result.then((result) => {
      // console.log(`Modal closed with result: ${result}`);
    }, (reason) => {
      // console.log(`Modal dismissed with reason: ${reason}`);
    });
  }
  submit(){
    this.task_leave_model.to = this.user_role.id
    this.task_leave_model.from_date = this.from_date.value
    this.task_leave_model.to_date = this.to_date.value
    this.task_leave_model.body 
    if(!this.row_id){
      this.apiService.createTask(this.task_leave_model).subscribe((res:any)=>{
        if(res.statusCode===200){
          this.toastr.success('leave added successfull!')
          this.modalService.dismissAll()
          this.getLeaveList(this.fromDate,this.toDate)
        }
        else{
          this.toastr.error(res.error)
        }
      })
    }
    if(this.row_id){
      this.apiService.updateTask(this.row_id,this.task_leave_model).subscribe((res:any)=>{
        if(res.statusCode===200){
          this.toastr.success('leave updated successfull!')
          this.modalService.dismissAll()
          this.getLeaveList(this.fromDate,this.toDate)
        }
        else{
          this.toastr.error(res.error)
        }
      })
    }
    
  }
  updateBody() {
      this.task_leave_model.body = `Hi,
      Please approve my leave request, details are mentioned below:
      From :- ${this.task_leave_model.from_date}
      To :- ${this.task_leave_model.to_date}
  
      Reason :- ${this.task_leave_model.title}
  
      Project Transferred To :- ${this.task_leave_model.knowledge_transafer}
  
      Let me know if I missed any point.
      I HERE BY CONFIRMED THAT SAME IS NOTIFIED TO CLIENT OR RESOURCE TO WHOM PROJECT IS TRANSFERRED. I WILL FURTHER UPDATE TO CLIENT / SENIOR BY REQUESTED MODE WHILE I WILL NOT AVAILABLE IN THE OFFICE PREMISES.
      
      Thanks,
      Regards,
      ${this.user_role.name}`;
   
  }
  openModalView(content,data,prop){
    if(prop == 'body'){
      this.request_info = data
    }
    if(prop == 'admin_notes'){
      this.reply_info = data
    }
    const modalOptions: NgbModalOptions = {
      size: 'lg' 
    };
    const modalRef = this.modalService.open(content,modalOptions);
    modalRef.result.then((result) => {
      this.reply_info =''
      this.request_info=''
      // console.log(`Modal closed with result: ${result}`);
    }, (reason) => {
      this.reply_info =''
      this.request_info=''
      // console.log(`Modal dismissed with reason: ${reason}`);
    });
  }
  checkEmpAttendence(data){
    
    this.apiService.checkEmpAttendance(data).subscribe((res:any)=>{
      this.emp_list = res?.data?.items
    })
  }
  getEmpId(event){
    this.selected_emp
    this.task_leave_model.knowledge_transafer = event.userName
    this.updateBody()
  }
  openDynamicModal(key_id:string) {
    const modalOptions: NgbModalOptions = {
      size: 'lg', // 'sm', 'lg', or 'xl'
      backdrop: 'static',
    };
    const modalRef = this.modalService.open(DynamicDetailComponent,modalOptions);
    modalRef.componentInstance.key_id = key_id;
  }

}
